class Modal {
  constructor (element) {
    this.element = element;
    this.id = this.element.getAttribute('data-js-modal-id');
    this.url = this.element.getAttribute('data-js-modal-url');
    this.modal = document.getElementById(this.id);
    this.overlay = this.modal.querySelector('.js-modal-overlay');
    this.close = this.modal.querySelector('.js-modal-close-button');
    this.video = this.modal.querySelector('.js-youtube-video');

    if( null !== this.overlay && null !== this.close && null !== this.video ) {
      this.init();
    }
  }

  init() {
    this.element.addEventListener('click', () => this.openModal());

    this.overlay.addEventListener('click', () => this.closeModal());
    this.close.addEventListener('click', () => this.closeModal());
  }

  openModal () {
    this.modal.classList.remove('hidden');
    this.toggleVideo('playVideo');
    document.body.classList.add('overflow-hidden');
  }

  closeModal () {
    this.modal.classList.add('hidden');
    this.toggleVideo('pauseVideo');
    document.body.classList.remove('overflow-hidden');
  }

  toggleVideo(state) {
    this.video.contentWindow.postMessage('{"event":"command","func":"' + state + '","args":""}', '*');
  }
}

export default function() {
  let modals = document.querySelectorAll('.js-button-open-modal');
  modals.forEach(el => {
    new Modal(el);
  });
}
